import { r as registerInstance, c as createEvent, f as forceUpdate, h, H as Host, g as getElement } from './index-ce7d0cf1.js';
import { g as getLanguageTag, a as getLanguageName, b as getCountryName, i as i18nProvider } from './index-5a73d8b4.js';

const getLanguageOptionName = (key) => {
    const locale = getLanguageTag(key).split("-");
    const languageName = getLanguageName(key) || key;
    if (locale.length < 2) {
        return languageName;
    }
    const countryName = getCountryName(key);
    return countryName ? `${languageName} (${countryName})` : languageName;
};
const getLanguageOptions = (lngs) => {
    if (!lngs || lngs.length === 0) {
        return [];
    }
    let locales;
    if (typeof lngs === "string") {
        locales = lngs.split(",").map(getLanguageTag);
    }
    else if (Array.isArray(lngs)) {
        locales = lngs
            .map((lng) => {
            if (typeof lng === "string") {
                return getLanguageTag(lng);
            }
            if (typeof lng === "object" && lng.value) {
                return Object.assign(Object.assign({}, lng), { name: lng.name || getLanguageOptionName(lng.value), value: getLanguageTag(lng.value) });
            }
        })
            .filter((lng) => !!lng);
    }
    else {
        return [];
    }
    return locales.map((key) => {
        return typeof key === "object"
            ? key
            : {
                name: getLanguageOptionName(key),
                value: key
            };
    });
};

const appLanguageSelectorCss = ":root,.uic-theme-responsive{--uxc-app-header-height:52px;--uxc-app-header-expandables-y-offset:56px;--uxc-app-header-expandables-min-width:300px;--uxc-app-header-z-index:400;--uxc-app-header-bg-color:var(--uic-color-blue5);--uxc-app-header-separator-color:var(--uic-color-white);--uxc-app-header-launcher-width:68px}@media only screen and (min-width: 1024px){.uic-theme-responsive{--uxc-app-header-height:68px;--uxc-app-header-expandables-y-offset:72px;--uxc-app-header-launcher-width:85px}}:root,.uic-theme-responsive{--uxc-app-toast-notifications-z-index:350}.uxc-app-language-selector{display:block}.uxc-app-language-selector uic-list-item .uic-list-item__content-default{line-height:1.6}.uxc-app-language-selector[slot=user-dialog]{--uic-dropdown-variant-content-min-width:186px;margin:1rem -8px;overflow:hidden;width:auto}";
const UxcAppLanguageSelectorStyle0 = appLanguageSelectorCss;

const baseClass = "uxc-app-language-selector";
const AppLanguageSelector = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.languageChangeEvent = createEvent(this, "uxLanguageChange", 7);
        this.i18nSubscriberId = "";
        this.handleI18n = ({ language }) => {
            if (this.passive) {
                this.updateOptions();
                return;
            }
            this.language = language;
            forceUpdate(this);
        };
        this.handleChange = (event) => {
            const lng = event.target.value;
            if (!lng) {
                return;
            }
            if (this.languageChangeEvent.emit(lng).defaultPrevented) {
                forceUpdate(this);
                return;
            }
            if (this.passive) {
                this.language = lng;
                return;
            }
            i18nProvider.changeLanguage(lng).then(() => {
                this.language = i18nProvider.language;
            });
        };
        this.passive = false;
        this.label = undefined;
        this.placeholder = undefined;
        this.language = undefined;
        this.languages = undefined;
        this.options = undefined;
    }
    /** Update local options */
    updateOptions() {
        const options = getLanguageOptions(this.languages).map((option) => (Object.assign(Object.assign({}, option), { selected: option.value === this.language })));
        const selectedOption = options.find((option) => !!option.selected);
        if (this.language && !selectedOption) {
            options.unshift(getLanguageOptions(this.language)[0]);
        }
        this.options = options;
    }
    componentWillLoad() {
        this.language = this.passive ? this.language : i18nProvider.language;
        this.updateOptions();
    }
    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(this.handleI18n);
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }
    componentDidRender() {
        this.element.querySelectorAll("option").forEach((option) => {
            option.selected = option.value === this.language;
        });
    }
    render() {
        const { handleChange, language, options } = this;
        const { t } = i18nProvider;
        const label = this.label || t(`userAccount.language.label`);
        return (h(Host, { key: 'a39f941bc1d5f9ccb8db20c1cc4006acd7e4cb16', class: baseClass }, h("uic-dropdown", { key: 'f64142bc5b2d001cdeca17499234137e269aa376', onUicChange: handleChange, label: label, value: language, placeholder: this.placeholder || t(`userAccount.language.select`), hoist: true }, options.map((option) => (h("uic-list-item", { key: `${option.value}-${option.name}`, value: option.value, selected: option.selected, disabled: option.disabled }, option.name))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "language": ["updateOptions"],
        "languages": ["updateOptions"]
    }; }
};
AppLanguageSelector.style = UxcAppLanguageSelectorStyle0;

export { AppLanguageSelector as uxc_app_language_selector };

//# sourceMappingURL=uxc-app-language-selector.entry.js.map